import { cn } from "@heroui/react";
import { m } from "framer-motion";
import type { RefObject } from "react";
import ConversationDetailEmpty from "./ConversationDetailEmpty";
import ConversationHeader from "./ConversationHeader";
import MessageComposer from "./MessageComposer";
import MessageList from "./MessageList";
import type { Conversation, InboxDemoIcons, InboxDemoNavigation } from "../data/types";

type ConversationViewProps = {
  conversation?: Conversation;
  emptyStateKey?: string;
  icons: InboxDemoIcons;
  draft: string;
  messageListRef: RefObject<HTMLDivElement | null>;
  navigation?: InboxDemoNavigation;
  className?: string;
  onBack?: () => void;
  onDraftChange: (value: string) => void;
  onSend: () => void;
  onUserIntent: () => void;
};

export default function ConversationView({
  conversation,
  emptyStateKey = "empty",
  icons,
  draft,
  messageListRef,
  navigation,
  className,
  onBack,
  onDraftChange,
  onSend,
  onUserIntent,
}: ConversationViewProps) {
  return (
    <section
      className={cn(
        "flex h-full min-w-0 flex-1 flex-col overflow-hidden rounded-[12px] bg-[var(--inbox-demo-panel-bg)]",
        className,
      )}
    >
      {conversation ? (
        <>
          <ConversationHeader
            conversation={conversation}
            icons={icons}
            onBack={onBack}
          />
          <m.div
            animate={{ opacity: 1, y: 0 }}
            className="flex min-h-0 flex-1 flex-col"
            initial={{ opacity: 0, y: 4 }}
            key={conversation.id}
            transition={{ duration: 0.18, ease: [0.22, 1, 0.36, 1] }}
          >
            <MessageList
              conversation={conversation}
              icons={icons}
              listRef={messageListRef}
              messages={conversation.messages}
              operatorAvatar={navigation?.userAvatar}
              operatorName={navigation?.userName}
              onUserIntent={onUserIntent}
            />
            <MessageComposer
              draft={draft}
              icons={icons}
              onDraftChange={onDraftChange}
              onSend={onSend}
              onUserIntent={onUserIntent}
            />
          </m.div>
        </>
      ) : (
        <m.div
          animate={{ opacity: 1 }}
          className="flex min-h-0 flex-1 flex-col"
          initial={{ opacity: 0 }}
          key={emptyStateKey}
          transition={{ duration: 0.18, ease: [0.22, 1, 0.36, 1] }}
        >
          <ConversationDetailEmpty />
        </m.div>
      )}
    </section>
  );
}
